import { format } from "date-fns";
import { sv } from "date-fns/locale";
import { useFormatters } from "@financialharmony/ui";

/** The long date a date picker echoes back ("October 15th, 2026" / "15 oktober 2026"), in the language the app shows. */
export function useFormatPickedDate() {
  const { locale } = useFormatters();
  return (date: Date) => format(date, "PPP", locale === "sv" ? { locale: sv } : undefined);
}
